// EventList.js
import Home from '../Home/Home';
import React, { useEffect, useState } from "react";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';




const GridComponent = () => {
    const [data, setData] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
      // Fetch data from the API
      axios.get(process.env.REACT_APP_API_URL + '/event/get/all') // Replace with your API endpoint
        .then(response => {
          setData(response.data);
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
    }, []);
    const handleEdit = (eventId) => {
     eventId=parseInt(eventId, 10);
      // Implement your edit logic here
      console.log('Edit item at event:', eventId);
       // Navigate to the Events component with the eventId
    navigate(`/event/create/${eventId}`);
    };
  
    const handleDelete = (eventId) => {
      // Implement your delete logic here
      console.log('Delete item at event:', eventId);
    };
  
    return (

        <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Event Type</th>
              <th>Event Year</th>
              <th>Event Month</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td>{item.eventType}</td> {/* Replace with the actual property from your API response */}
                <td>{item.eventYear}</td> {/* Replace with the actual property from your API response */}
                <td>{item.eventMonth}</td> {/* Replace with the actual property from your API response */}
                <td>
                  <button onClick={() => handleEdit(item.eventId)}>Edit</button>
                  &nbsp;&nbsp;&nbsp;
                  <button onClick={() => handleDelete(item.eventId)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
     


  };

const Eventlist = ({ events }) => {
  return (
    <Home>
    <div className="event-grid">
    <h1>Event List Items</h1>
    <GridComponent />
    </div>
    </Home>
  );
};

export default Eventlist;